export default {
  common: {
    save: 'Save',
    cancel: 'Cancel',
    ok: 'OK',
    copied: 'Copied',
    selectAllLabel: 'Select All',
    submit: 'Submit',
    logout: 'Logout',
    skip: 'Skip',
    viewMore: 'View more',
    viewLess: 'View less',
    changeLanguage: 'Change language',
    areYouSure: 'Are you sure?',
    done: 'Done',
    error: 'Error',
    close: 'Close',
    noResultsFound: 'No Results Found',
    typeToSearch: 'Type something to search!',
    typeToSearchPlaceholder: 'Type to search',
    active: 'Active',
    edit: 'Edit',
    updatedSuccessfully: 'Updated successfully',
    success: 'Success',
    addedSuccessfully: 'Added successfully',
    date: 'Date',
    user: 'User',
    new: 'New',
    delete: 'Delete',
    cash: 'Cash',
    deletedSuccessfully: 'Deleted successfully',
    back: 'Back',
    inactive: 'Inactive',
    all: 'All',
    add: 'Add',
    create: 'Create',
    update: 'Update',
    reset: 'Reset',
    editQuestion: 'edit?',
    search: 'Search',
    select: 'Select',
    filterColon: 'Filter:',
    showResultLabel: 'Show',
    resultLabel: 'Result',
    totalResultLabel: 'Total Result {count}',
    selectedCountLabel: '{count} selected',
    of: 'of',
    canceledStatus: 'Canceled',
    refundedStatus: 'Refunded',
    mobileSource: 'Mobile',
    webSource: 'Web',
    adminSource: 'Admin',
    warning: 'Warning',
    yes: 'Yes',
    no: 'No',
    example: 'e.g. {value}'
  },
  columns: {
    id: 'ID',
    item: 'Item',
    itemCode: 'Item Code',
    customer: 'Customer',
    name: 'Name',
    email: 'Email',
    phoneNumber: 'Phone Number',
    itemName: 'Item Name',
    brand: 'Brand',
    url: 'URL',
    image: 'Image',
    dateTime: 'Date & Time',
    status: 'Status',
    statuses: 'Statuses',
    checkBoxColumn: 'Check Box',
    warehouse: 'Warehouse',
    branch: 'Branch',
    role: 'Role',
    summary: 'Summary',
    shipping: 'Shipping',
    total: 'Total',
    qty: 'Qty',
    size: 'Size',
    price: 'Price',
    logo: 'Logo',
    defaultImage: 'Default Image',
    country: 'Country',
    currency: 'Currency',
    prefix: 'Prefix',
    transportationTypes: 'Transportation Types',
    city: 'City',
    street: 'Street',
    code: 'Code',
    houseNumber: 'House Number',
    estimateDays: 'Estimate days',
    actions: 'Actions',
    stateProvince: 'State - Province',
    flagCode: 'Flag Code',
    customCode: 'Custom Code',
    qr: 'QR',
    customerId: 'Customer ID',
    phone: 'Phone',
    headQuarter: 'Head Quarter',
    type: 'Type',
    purchaseNote: 'Purchase Note',
    bank: 'Bank',
    invoiceNo: 'Invoice No.',
    orderId: 'OrderID',
    productName: 'Product Name',
    quantity: 'Quantity',
    note: 'Note',
    qrId: 'Qr ID',
    payment: 'Payment',
    orderInfo: 'Order Info',
    itemDetails: 'Item Details',
    product: 'Product',
    statusLocation: 'Status & Location',
    pricing: 'Pricing',
    datePayment: 'Date & Payment',
    invoiceInfo: 'Invoice Info',
    shipmentCosts: 'Shipment Costs',
    cleared: 'Cleared',
    purchaseDate: 'Purchase Date',
    warehouseDate: 'Warehouse Date',
    bankName: 'Bank Name',
    actualCost: 'Actual Cost',
    purchaseCost: 'Purchase Cost',
    totalAmount: 'Total Amount',
    purchasedBy: 'Purchased By',
    refundNumber: 'Refund Number',
    refundNote: 'Refund Note',
    discount: 'Discount',
    weight: 'Weight',
    deliveryPrice: 'Delivery Price',
    nationalTax: 'National Tax',
    totalRefunded: 'Total Refunded',
    refundStatus: 'Refund Status',
    trackNumber: 'Track Number',
    orderNumber: 'Order Number',
    createDate: 'Create Date',
    caseId: 'Case ID',
    caseOrderId: 'Order ID',
    createdBy: 'Created By',
    customerPhone: 'Customer Phone',
    sentBy: 'Sent By',
    deadline: 'Deadline',
    attachedInvoices: 'Attached Invoices',
    customerPhone2: 'Customer Phone 2',
    defaultLocation: 'Default Location',
    totalPrice: 'Total Price',
    orderHash: 'Order #',
    volume: 'Volume',
    handlingFee: 'Handling Fee',
    shipment: 'Shipment',
    tax: 'Tax',
    amount: 'Amount',
    paidAmount: 'Paid Amount',
    remaining: 'Remaining',
    outOffice: 'Out Office',
    owner: 'Owner',
    receivedDate: 'Received Date',
    receivedAmount: 'Received Amount',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    checkBox: 'Check box',
    deliveryAddress: 'Delivery Address',
    generatedBy: 'Generated By',
    dateFilterByLabel: 'Date Filter By',
    selectedSuffix: 'selected',
    orderStatus: 'Order Status',
    productUrl: 'Product URL',
    transactionDate: 'Transaction Date',
    staffName: 'Staff Name',
    action: 'Action',
    exRate: 'Ex Rate',
    paymentMethod: 'Payment Method',
    logDate: 'Log Date',
    cid: 'CID',
    subscription: 'Subscription',
    rateLog: 'Rate Log',
    paidVia: 'Paid via',
    title: 'Title',
    order: 'Order',
    question: 'Question',
    answer: 'Answer',
    coupon: 'Coupon',
    expireDate: 'Expire Date',
    percentage: 'Percentage',
    nameArabic: 'Name (Arabic)',
    nameKurdish: 'Name (Kurdish)',
    reasonEnglish: 'Reason English',
    reasonArabic: 'Reason Arabic',
    reasonKurdish: 'Reason Kurdish',
    shipzoneFee: 'Shipzone Fee',
    handlingFeeAir: 'Handling Fee (Air)',
    handlingFeeSea: 'Handling Fee (Sea)',
    itemPriceAir: 'Item Price (Air)',
    itemPriceSea: 'Item Price (Sea)',
    itemPriceLand: 'Item Price (Land)',
    localDelivery: 'Local Delivery',
    default: 'Default',
    netPrice: 'Net price',
    transportationType: 'Transportation Type',
    ordersStatus: 'Orders Status',
    postalCode: 'Postal Code',
    customerName: 'Customer Name',
    customerNote: 'Customer Note',
    phoneNumber2: 'Phone Number 2',
    governorate: 'Governorate',
    address: 'Address',
    credit: 'Credit',
    shipOnly: 'Ship Only',
    cancelReason: 'Cancel Reason',
    description: 'Description',
    verified: 'Verified',
    unverified: 'Unverified',
    verifyFilterLabel: 'Verify Filter',
    staff: 'Staff',
    balance: 'Balance',
    initialBalance: 'Initial Balance',
    debit: 'Debit',
    transactionType: 'Transaction Type',
    source: 'Source',
    sourceId: 'Source ID',
    orderType: 'Order Type',
    orderTypeName: 'Order Type Name',
    phone2: 'Phone2',
    receivedDeliveryAmount: 'Received Delivery Amount',
    preview: 'Preview',
    linkUrl: 'Link (URL)',
    qrCode: 'QrCode',
    domain: 'Domain',
    platform: 'Platform',
    invoiceNumber: 'Invoice Number',
    refundBy: 'Refund By',
    confirmDate: 'Confirm Date',
    fromDate: 'From Date',
    toDate: 'To Date',
    buyCost: 'Buy cost',
    intShipping: 'Int Shipping',
    usdPrice: 'USD Price',
    tlPrice: 'TL Price',
    exchangeDate: 'Exchange Date',
    book: 'Book',
    fromBank: 'From Bank',
    toBank: 'To Bank',
    expenseAmount: 'Expense Amount',
    iqdSell: 'IQD Sell',
    iqdBuy: 'IQD Buy',
    tlSell: 'TL Sell',
    tlBuy: 'TL Buy',
    aedSell: 'AED Sell',
    aedBuy: 'AED Buy',
    cnySell: 'CNY Sell',
    cnyBuy: 'CNY Buy',
    gbpSell: 'GBP Sell',
    gbpBuy: 'GBP Buy',
    eurSell: 'EUR Sell',
    eurBuy: 'EUR Buy',
    expenseType: 'Expense Type',
    supplierInvoiceNo: 'Supplier Inv. No.',
    supplier: 'Supplier',
    expenseDate: 'Expense Date',
    noAbbreviation: 'No'
  },
  orders: {
    newOrdersTitle: 'New Orders',
    pendingAnswerOrdersTitle: 'Pending Answer Orders',
    processedOrdersTitle: 'Processed Orders',
    canceledOrdersTitle: 'Canceled Orders',
    processOrderTooltip: 'Process Order',
    approveThisOrderTooltip: 'Approve This Order',
    returnToNewOrderTooltip: 'Return to New Order',
    returnToShipOnlyTooltip: 'Return to Ship Only',
    errorOccurredProcessingOrder: 'An error occurred while processing this order',
    errorOccurredSubmittingOrders: 'An error occurred while submitting orders',
    couldNotFetchOrderDetails: 'Could not fetch order details',
    failedToCancelOrder: 'Failed to cancel order',
    sumOfSelectedOrdersLabel: 'Sum of selected orders',
    failedToSendOrdersToIntShipment: 'Failed to send orders to Int Shipment',
    failedToSendOrdersToBranchDelivery: 'Failed to send orders to Branch Delivery',
    failedToUnclearOrders: 'Failed to unclear orders',
    failedToMarkOrdersAsDelivered: 'Failed to mark orders as delivered',
    missingQrCodeForMessage: 'Missing QR code for: {list}. The rest were delivered successfully — generate a QR code for these and try again.',
    customerHasLoanMustPayMessage: 'This customer ({name}) has loan and must pay at least ${amount}',
    returnToProcessedOrderTooltip: 'Return to Processed Order',
    ordersReturnedToNewOrderSection: 'The orders returned to new order section',
    orderUpdatedTitle: 'Order Updated',
    pleaseSelectOrderToPurchase: 'Please select some order to purchase',
    pleaseRefreshPageAndTryAgain: 'Please refresh the page and try again',
    pleaseCheckOrderToApprove: 'Please check some order to approve',
    onceConfirmedAllApproved: 'Once confirmed, all checked order will be approved',
    viewOrderInvoiceConfirm: 'Do you want to see this order invoice ?',
    pleaseSelectOrderToDelete: 'Please select at least one order to delete',
    deleteSelectedCanceledOrdersConfirm: 'Delete all selected canceled orders? This cannot be undone from this screen.',
    permanentlyDeleteTitle: 'Permanently delete?',
    permanentlyDeleteCanceledOrdersConfirm: 'This removes the selected canceled orders from the database completely — unlike "Delete Selected Orders", this cannot be recovered. The customer\'s transaction history and balance are not affected.',
    undoCancelOrderConfirm: 'Undo Cancel Order will restore the order to the previous status.',
    warehouseDeliveredOrdersTitle: 'Warehouse Delivered Orders',
    allOrdersTitle: 'All Orders',
    deliveredToErbilOrdersTitle: 'Delivered',
    purchasedOrdersTitle: 'Purchased Orders',
    approvedOrdersTitle: 'Approved Orders',
    internationalShipmentOrdersTitle: 'Shipment',
    pendingToBranchOrdersTitle: 'Pending to Branch Orders',
    refundedOrdersTitle: 'Refunded Orders',
    customerDeliveredOrdersTitle: 'Customer Delivered Orders',
    exportableOrdersTitle: 'Exportable Orders',
    warehousePassedOrdersTitle: 'Warehouse Passed Orders',
    purchaseHistoryTitle: 'Purchase History',
    viewShippingInvoiceTooltip: 'View Shipping Invoice',
    generateQrCodeTooltip: 'Generate QR Code',
    generateInvoiceTooltip: 'Generate Invoice',
    moveToDamageTooltip: 'Move to Damage',
    moveToReturnTooltip: 'Move to Return',
    sendToCustomerTooltip: 'Send to customer',
    copyToNewOrderTooltip: 'Copy to New Order',
    refundThisOrderTooltip: 'Refund This Order',
    addOrderNumberTooltip: 'Add Order Number',
    orderNumberAddedSuccessfully: 'Order Number added successfully',
    addWarehouseDateTooltip: 'Add warehouse date',
    purchaseThisOrderTooltip: 'Purchase This Order',
    addBarcodeTooltip: 'Add Barcode',
    deliverToPendingToBranchTooltip: 'Deliver to pending to branch',
    sendToBranchDeliveryTooltip: 'Send to Branch Delivery',
    deliverToBranchTooltip: 'Deliver to branch',
    pleaseSelectOrderOrCustomer: 'Please at least select one order or customer!',
    selectedDifferentCustomers: 'You selected different customers',
    someOrdersAlreadyInvoiced: 'Some selected orders are already invoiced',
    copyToNewOrderConfirmTitle: 'Copy to New Order?',
    copyToNewOrderConfirmMessage: 'This will cancel order {id}, refund the customer in full, and create a new copy in New Orders for you to reprice. Continue?',
    ordersPurchasedSuccessfully: 'Orders purchased successfully',
    orderPurchasedSuccessfully: 'Order purchased successfully',
    sentSuccessfully: 'Sent successfully',
    onceDeliveredPendingBranchWarning: 'Once delivered to pending to branch, you will not be able to return this order to this step!',
    confirmSendToBranchDelivery: 'This will send the selected orders directly to Branch Delivery.',
    sortByOrder: 'Order',
    sortByConfirm: 'Confirm',
    sortByPurchase: 'Purchase',
    someOrdersNotMarkedDelivered: 'Some orders were not marked delivered',
    orderAlreadyInvoicedTitle: 'This order is already invoiced',
    confirmAttachToDeliveryRequest: "This will attach the selected order(s) to this customer's delivery request — creating one if they don't already have a pending request.",
    moveToDamageConfirmTitle: 'Move to Damage?',
    confirmMoveToDamage: 'Are you sure you want to move this order to damage status?',
    moveToReturnConfirmTitle: 'Move to Return?',
    confirmMoveToReturn: 'Are you sure you want to move this order to return status?',
    editThisOrderTooltip: 'Edit This Order',
    addRefundNumberTooltip: 'Add refund number',
    onceSentWarning: 'Once sent, you will not be able to return this order to this step!',
    onceSentPluralWarning: 'Once sent, you will not be able to return these order to this step!',
    confirmGenerateQrSendIntShipment: 'This will generate QR codes for the selected orders and send them directly to Int Shipment.',
    confirmSendDirectlyToBranchDelivery: 'This will send this order directly to Branch Delivery. You will not be able to return it to this step!',
    pendingShipmentTooltip: 'Pending Shipment',
    sendToIntShipmentTitle: 'Send to Int Shipment',
    returnToPurchaseTooltip: 'Return to purchase',
    takePhotoTooltip: 'Take Photo',
    createCaseTooltip: 'Create Case',
    pleaseAtLeastSelectOneOrder: 'Please at least select one order!',
    currentPageScopeNote: 'current page',
    filtersToggleLabel: 'Filters',
    oncePendingShipmentedWarning: 'Once Pending shipmented, you will not be able to return this order to this step!',
    confirmReturnToPurchasedSection: 'You really want to return this order to Purchased section?',
    damageOrdersTitle: 'Damage Orders',
    returnOrdersTitle: 'Return Orders',
    cancelOrderTooltip: 'Cancel Order',
    newExportOrdersTitle: 'New Export Orders',
    processedExportOrdersTitle: 'Processed Export Orders',
    canceledExportOrdersTitle: 'Canceled Export Orders',
    approvedExportOrdersTitle: 'Approved Export Orders',
    sentExportOrdersTitle: 'Sent Export Orders',
    receivedExportOrdersTitle: 'Received Export Orders',
    exportHistoryTitle: 'Export History',
    refundedExportOrdersTitle: 'Refunded Export Orders',
    processTooltip: 'Process',
    cancelTooltip: 'Cancel',
    approveTooltip: 'Approve',
    sendTooltip: 'Send',
    receiveTooltip: 'Receive',
    partialRefundTooltip: 'Partial Refund',
    fullRefundTooltip: 'Full Refund',
    approvedStatusTitle: 'Approved',
    sentStatusTitle: 'Sent',
    receivedStatusTitle: 'Received',
    pendingToShipmentOrdersTitle: 'Pending To Shipment Orders',
    shipmentThisOrderTooltip: 'Shipment this order',
    onceShipmentedWarning: 'Once shipmented, you will not be able to return this order to this step!',
    notFoundOrdersTitle: 'Not Found Orders',
    trashTooltip: 'Trash',
    allowToSendTooltip: 'Allow to send',
    convertToOrderTooltip: 'Convert to order',
    convertToOrderTitle: 'Convert To Order',
    deliveredToErbilOption: 'Delivered to Erbil',
    addedTitle: 'Added',
    orderCasesTitle: 'Order Cases',
    sendToStaffTooltip: 'Send to staff',
    refundTooltip: 'Refund',
    replaceTooltip: 'Replace',
    imagesTooltip: 'Images',
    orderCaseProgressTitle: 'Order Case Progress',
    convertedToOrderStatus: 'Converted to order',
    pendingStatus: 'Pending',
    processingStatus: 'Processing',
    viewDetails: 'View Details',
    cancelThisOrder: 'Cancel This Order',
    sendToPendingAnswerTooltip: 'Send to pending answer',
    sendToProcessTooltip: 'Send to Process',
    orderSort: 'Order Sort',
    dateTypeLabel: 'Date Type',
    newestFirst: 'Newest First',
    oldestFirst: 'Oldest First',
    homeDelivery: 'Home Delivery',
    officeDelivery: 'Office Delivery',
    sendThisOrderToProcess: 'Send this order to Process?',
    sendAllSelectedToProcess: 'Send all selected orders to Process?',
    sendToPendingAnswerConfirm: 'Send to Pending Answer',
    pleaseSelectOrder: 'Please select order',
    warehousesPlaceholder: 'Warehouses',
    processThisOrderTooltip: 'Process This Order',
    theOrderIsProcessed: 'The Order is Processed',
    editOrderInfoSection: 'Edit Order Info',
    customerLockedHint: 'Locked — use Reassign Order Customer to change the customer',
    requestName: 'Request Name',
    requestLink: 'Request Link',
    uploadOrderImage: 'Upload Order Image',
    requestDescription: 'Request Description',
    editOrderPriceSection: 'Edit Order Price',
    itemPriceLabel: 'Item Price ({unit})',
    discountedShippingPriceLabel: 'Discounted shipping price ($)',
    discountLabel: 'Discount ({unit})',
    deliveryIqdLabel: 'Delivery (IQD)',
    estimateTimeToArrivalLabel: 'Estimate Time to Arrival (days)',
    customerProcessNoteLabel: 'Customer Process note',
    uploadImage: 'Upload Image',
    otherServiceNoteLabel: 'Other service note',
    reason: 'Reason',
    bulkNewOrdersTitle: 'Bulk New Orders',
    allItemsOrderedSuccessfully: 'All items ordered successfully!',
    customerRequiredError: 'Customer is required',
    warehouseCountryLabel: 'Warehouse / Country',
    warehouseRequiredError: 'Warehouse is required',
    itemNamePlaceholder: 'Item name',
    addRowButton: 'Add Row',
    countPlaceholder: 'Count',
    numberOfRowsToAddHint: 'Number of rows to add (0 or blank = 1)',
    itemsTotalLabel: '{count} item(s) total',
    sendToPurchaseLabel: 'Send to Purchase',
    submitAllOrdersButton: 'Submit All Orders',
    removeRowTitle: 'Remove Row',
    pickColorTitle: 'Pick a color',
    maxOrdersLimitError: 'You can add up to {max} orders at once.',
    onlyRowsAddedLimitError: "Only {count} row(s) added — the {max} order limit was reached.",
    unsupportedImageTypeError: 'File "{fileName}" is not a supported image type. Allowed: {allowed}.',
    fileSizeLimitError: 'File "{fileName}" exceeds the 50MB size limit.',
    uploadingImagesProgress: 'Uploading images {done}/{total}...',
    savingOrders: 'Saving orders...',
    gifSizeLimitError: 'GIF "{fileName}" exceeds the 2MB limit. Please use a JPG or PNG instead.',
    imagesStillProcessingError: 'Some images are still being prepared. Please wait a moment and submit again.',
    uploadTooLargeError: 'The upload is too large for the server. Please upload fewer or smaller images.',
    rowItemNameRequiredError: 'Row {row}: Item name is required.',
    rowLinkRequiredError: 'Row {row}: Link (URL) is required.',
    rowQuantityMinError: 'Row {row}: Quantity must be at least 1.',
    viewOrderDetailsTitle: 'View Order Details',
    itemPriceCurrencyLabel: 'Item Price {code}',
    refundAmountLabel: 'Refund Amount',
    partialRefundsLabel: 'Partial Refunds',
    partialRefundAtBy: 'at {date} by {name}',
    newOrderTitle: 'New order',
    itemOrderedSuccessfully: 'Item ordered successfully',
    urlFormatNotAcceptable: 'URL format not acceptable',
    intShippingUsdLabel: 'Int. Shipping ($)',
    imageUrlOptionalLabel: 'Image URL (optional)',
    urlWillBeUsedInsteadHint: 'URL will be used instead of file upload',
    purchaseBankLabel: 'Purchase Bank',
    otherServiceSpecifyLabel: 'Other service (please specify)',
    couponCodeRequiredError: 'This field must contain a Coupon Code',
    fileSizeExceedsError: 'The {field} must not exceed {size} MB.',
    unsupportedImageTypeShort: 'Unsupported image type. Allowed: {allowed}.',
    fileSizeLimitShort: 'File exceeds the 50MB size limit.',
    uploadPhotoButton: 'Upload Photo',
    partialRefundInvoiceTitle: 'Partial Refund Invoice',
    newStatus: 'new',
    updateShipOnlyTitle: 'Update shiponly',
    newShipOnlyTitle: 'New shiponly',
    orderedSuccessfully: 'Ordered successfully',
    fromDateGreaterThanTodayError: 'From date must be greater than Today',
    toDateGreaterThanFromDateError: 'To date must be greater than From date'
  },
  delivery: {
    orderDeliveryTitle: 'Order Delivery',
    changeStatusTooltip: 'Change Status',
    viewInvoiceTooltip: 'View Invoice',
    viewCustomerOrdersImagesTooltip: 'View Customer Orders & Images',
    editDeliveryPriceTooltip: 'Edit Delivery Price',
    deliveryRequestDeleteConfirm: 'This delivery request will be permanently deleted.',
    deletedTitle: 'Deleted',
    deliveryPriceIqdTitle: 'Delivery Price (IQD)',
    deliveryPricePlaceholder: 'Delivery price',
    pleaseSelectAtLeastOneDeliveryRequest: 'Please select at least one delivery request!',
    postStatus: 'Post',
    holdStatus: 'Hold',
    completeStatus: 'Complete',
    orderDeliveryInvoiceTitle: 'Order Delivery Invoice',
    invoicedToLabel: 'Invoiced To',
    phone2Label: 'Phone 2',
    detachTooltip: 'Detach from this delivery request',
    orderNumberColumn: 'Order #',
    totalOrdersLabel: 'Total Orders:',
    totalUsdLabel: 'Total USD:',
    iraqiDinarLabel: 'IRAQI DINAR:',
    totalIqdColonLabel: 'Total IQD:',
    attachedOrdersNotYetInvoiced: 'Attached Orders (not yet invoiced)',
    orderColumn: 'Order',
    productColumn: 'Product',
    detachConfirmTitle: 'Detach this invoice?',
    detachConfirmText: '{invoice} will no longer be part of this delivery request. It stays as a normal shipping invoice and can be attached again later.',
    deliveryInvoiceTitle: 'Delivery Invoice',
    customerBalanceLabel: 'Customer Balance:',
    deliveryMethodLabel: 'Delivery Method:',
    pickupInOfficeLabel: 'Pickup (In Office)',
    payOnDeliveryLabel: 'Pay On Delivery:',
    deliveryInvoicesTitle: 'Delivery Invoices',
    invoiceSelectedCount: '{count} invoice(s) selected',
    selectStatusLabel: 'Select Status',
    totalRecordsFooter: 'Total Records: {count}',
    totalPriceFooter: 'Total Price: {amount}',
    totalDeliveryPriceFooter: 'Total Delivery Price: {amount} IQD',
    deliveryPriceFooter: 'Delivery Price: {amount} IQD',
    viewShippingInvoicesTooltip: 'View {count} Shipping Invoice(s)',
    thisDeliveryInvoiceWillBeDeleted: 'This delivery invoice will be permanently deleted.',
    pleaseSelectAtLeastOneDeliveryInvoice: 'Please select at least one delivery invoice!',
    markAllSelectedInvoicesAsReceivedConfirm: 'This will mark all selected delivery invoices as received.',
    unmarkAllSelectedInvoicesAsReceivedConfirm: 'This will unmark all selected delivery invoices as received (received amounts and date will be cleared).',
    partialReceivedStatus: 'Partial Received',
    payOnDeliveryIqdLabel: 'Pay on delivery (IQD)',
    pickupLabel: 'Pickup',
    notConfirmedLabel: 'Not confirmed',
    requestDeliveryTitle: 'Request Delivery',
    customerRequiredLabel: 'Customer*',
    noteOptionalLabel: 'Note (optional)',
    changeStatusTitle: 'Change Status',
    requestsSelectedSuffix: 'request(s) selected',
    invoiceColonPrefix: 'Invoice:',
    custNoteColumn: 'Cust. Note',
    createdColumn: 'Created'
  },
  invoice: {
    shippingInvoiceTitle: 'Shipping Inv.',
    receivedInvoicesTitle: 'Received Invoices',
    invoiceTooltip: 'Invoice',
    recordPaymentTooltip: 'Record Payment',
    logsTooltip: 'Logs',
    failedToDeleteInvoice: 'Failed to delete invoice — it was not removed.',
    somethingWentWrong: 'Something went wrong!',
    pleaseSelectAtLeastOneInvoice: 'Please select at least one invoice!',
    ordersInvoiceTitle: 'Orders Invoice',
    creditInvoiceTitle: 'Credit Invoice',
    confirmMarkAllPaid: 'This will mark all selected invoices as fully paid.',
    confirmMarkAllReceived: 'This will mark all selected invoices as received.',
    confirmUnmarkAllReceived: 'This will unmark all selected invoices as received (owner, received date and received amount will be cleared).',
    cashReceivedInDaysLabel: 'Cash received on these days:',
    cashReceivedInDaysHint: 'Only the new money handed over on the selected receive dates. Unlike Total Received, it does not move when an invoice is received again later.',
    confirmToggleOutOffice: 'This will toggle the out office status of selected invoices.',
    pleaseSelectAtLeastTwoPaidInvoices: 'Please select at least two paid invoices to merge!',
    paidStatus: 'Paid',
    partialPaidStatus: 'Partial Paid',
    unpaidStatus: 'Unpaid',
    receivedAtOption: 'Received At',
    singleOption: 'Single',
    batchOption: 'Batch',
    digitalOption: 'Digital',
    officeOption: 'Office',
    manualOption: 'Manual',
    refundExistsOption: 'Refund Exists',
    noRefundOption: 'No Refund',
    generateInvoiceTitle: 'Generate Invoice',
    customerLabel: 'Customer: {name}',
    phoneNumberLabel: 'Phone number: {phone}',
    ordersLabel: 'Orders',
    shipmentLabel: 'Shipment',
    handlingFeeLabel: 'Handling Fee',
    totalPriceLabel: 'Total price',
    totalIqdLabel: 'Total IQD',
    paidAmountLabel: 'Paid amount',
    remainingAfterSelectedOrders: "Remaining after selected orders' existing invoices: {usd} / {iqd} IQD",
    remainingFromOtherPartialInvoices: 'Remaining from other partial paid invoices: {usd} / {iqd} IQD',
    loadingText: 'Loading...',
    balanceLabel: 'Balance',
    remainingBalanceLabel: 'Remaining Balance',
    shippingInvoiceNoLabel: 'Shipping invoice no:',
    customerOutOfficeTotalNote: 'Total Out Office for this customer: {amount}',
    cashAndView: 'Cash and view',
    outOfficeButton: 'Out Office',
    viewButton: 'View',
    deliveryButton: 'Delivery',
    cancelStatus: 'Cancel',
    notPaidWatermark: 'NOT PAID',
    invoiceNoteLabel: 'Invoice Note:',
    secondaryInvoiceGeneratedNote: 'Secondary invoice for this order is generated',
    invoiceSavedNoPreview: 'Invoice saved but could not open preview (missing invoice id).',
    invoiceGeneratedSuccessfully: 'Invoice generated successfully',
    requestFailed: 'Request failed',
    invoiceSavedNoAttach: 'Invoice saved but could not attach to delivery (missing invoice id).',
    attachFailed: 'Attach failed',
    invoiceCreatedCouldNotAttach: 'Invoice was created, but could not attach: {msg}',
    alreadyAttachedNote: '{list} already attached to a delivery request — not attached again.'
  },
  navbar: {
    creditLabel: 'Credit:',
    addBalance: 'Add Balance',
    subscription: 'Subscription',
    exchangeRateLabel: 'Exchange Rate:',
    capital: 'Capital',
    verifyAccountButton: 'Verify your account',
    printLogs: 'Print Logs',
    warehouseDatePassedOrders: 'Warehouse date passed orders',
    warehouseDateLabel: 'Wh. Date:',
    notifications: 'Notifications'
  },
  sidebar: {
    toggleAllNavigations: 'Toggle All Navigations',
    dashboard: 'Dashboard',
    statisticsDashboard: 'Statistics Dashboard',
    loanedCustomerTitle: 'Loaned customer',
    customerPricesTitle: 'Customer prices',
    orderCasesProgressTitle: 'Order Cases Progress',
    orderTypesTitle: 'Order Types',
    chargeBalanceTitle: 'Charge Balance',
    shipOnlyNewTitle: 'Ship Only (New)',
    orderInvoicesTitle: 'Order Invoices',
    shippingInvoicesTitle: 'Shipping Invoices',
    creditInvoicesTitle: 'Credit Invoices',
    partialRefundInvoicesTitle: 'Partial Refund Invoices',
    orders: 'Orders',
    tools: 'Tools',
    export: 'Export',
    import: 'Import',
    delivery: 'Delivery',
    invoices: 'Invoices',
    finance: 'Finance',
    cases: 'Cases',
    customers: 'Customers',
    reports: 'Reports',
    mobileApp: 'Mobile App',
    admin: 'Admin'
  },
  warehouse: {
    warehousesTitle: 'Warehouses',
    updateWarehouseTitle: 'Update Warehouse',
    warehouseUpdatedSuccessfully: 'Warehouse updated successfully',
    estimateDaysLabel: 'Estimate days (delivery window)',
    houseNumberLabel: 'House Number',
    stateProvinceLabel: 'State - Province',
    prefixLabel: 'Prefix',
    flagCodeHint: 'Flag Code (ISO 2-letter, e.g. tr, us, ae, cn, gb, de)',
    customCodeLabel: 'Custom Code',
    transportationTypesLabel: 'Transportation Types',
    defaultImageLabel: 'Default Image'
  },
  user: {
    staffTitle: 'Staff',
    totalIncomeAddLabel: 'Total income (Add +)',
    totalOutgoingCashBackLabel: 'Total outgoing (CashBack -)',
    verifiedAtLabel: 'Verified at',
    customersTitle: 'Customers',
    editCustomerTooltip: 'Edit Customer',
    customerTransactionTooltip: 'Customer transaction',
    customerTransactionsTitle: '{name} Transactions',
    removeFilterButton: 'Remove Filter',
    openingBalanceLabel: 'Opening Balance',
    updateCustomerTitle: 'Update Customer',
    codEnabledLabel: 'Cash on Delivery',
    codEnabledHint: 'Allow this customer to approve orders without wallet balance',
    block: 'Block',
    unblock: 'Unblock',
    editStaffTooltip: 'Edit Staff',
    resetPasswordTooltip: 'Reset Password',
    resetPasswordSuccessfully: 'Password reset successfully',
    blockThisUserTooltip: 'Block This User',
    unblockThisUserTooltip: 'Unblock This User',
    notAllowed: 'Not Allowed',
    cannotResetOwnPassword: "You can't reset your password here, You can only reset password for others",
    personalInformation: 'Personal Information',
    updateCoverImageButton: 'Update Cover Image',
    fullName: 'Full Name',
    addCustomerTitle: 'Add Customer',
    customerFullNameLabel: 'Customer Full Name',
    fullNameTwoWordsError: 'Full name must contain at least two words separated by space',
    addStaffTitle: 'Add staff',
    staffAddedSuccessfully: 'Staff added successfully',
    passwordDoNotMatch: 'Password do not match',
    phoneMustStartWith964Error: 'Phone number must start with +964',
    updateStaffTitle: 'Update staff',
    staffUpdatedSuccessfully: 'Staff updated successfully',
    changePasswordTitle: 'Change Password',
    currentPassword: 'Current password',
    newPassword: 'New password',
    confirmPassword: 'Confirm password',
    changeSecretKeyTitle: 'Change Secret Key',
    currentSecret: 'Current secret',
    newSecret: 'New secret',
    confirmSecret: 'Confirm secret',
    createSecretKeyTitle: 'Create Secret Key',
    secretKey: 'Secret key',
    companyInfoTitle: 'Company info',
    companyName: 'Company name',
    companyEmail: 'Company email',
    companyAddress: 'Company address',
    confirmPasswordNotMatch: 'Confirm password not match',
    passwordChangedSuccessfully: 'Password Changed Successfully',
    currentPasswordIncorrect: 'Current Password is not correct',
    profileMustBeImage: 'Profile must be an image',
    coverMustBeImage: 'Cover must be an image',
    secretKeyIncorrect: 'Current secret key is not correct',
    secretKeyChangedSuccessfully: 'Secret key changed successfully',
    currentSecretKeyRequired: 'Current secret key is required',
    newSecretKeyRequired: 'New secret key is required',
    confirmSecretKeyRequired: 'Confirm secret key is required',
    confirmSecretNotMatch: 'Confirm secret is not match',
    secretKeyCreatedSuccessfully: 'Secret key created successfully',
    alreadyHaveSecretKey: 'You already have a secret key',
    secretKeyRequired: 'Secret key is required',
    companyInfoUpdatedSuccessfully: 'Company info updated successfully',
    customerSubscriptionsTitle: 'Customer Subscriptions',
    editSubscriptionTooltip: 'Edit Subscription',
    deleteCustomerSubscriptionTooltip: 'Delete Customer Subscription',
    pleaseSelectAtLeastOneSubscriptionToDelete: 'Please select at least one customer subscription to delete',
    deleteCustomerSubscriptionConfirm: 'Delete customer subscription: {name}?',
    deleteAllCustomerSubscriptionsConfirm: 'Delete all selected customer subscriptions?',
    customerCreditTitle: 'Customer Credit',
    onceDeletedCreditWarning: 'Once deleted, you will not be able to return this credit!',
    onceDeletedCashBackWarning: 'Once deleted, you will not be able to return this cash back!',
    customerDefaultPricesTitle: 'Customer default prices'
  },
  reports: {
    salesReportTitle: 'Sales Report',
    gainedReportTitle: 'Gained Report',
    expensesReportTitle: 'Expenses Report',
    invoicesReportTitle: 'Invoices Report',
    orderCostsReportTitle: 'Order Costs Report',
    buysReportTitle: 'Buys Report',
    customersReportTitle: 'Customers Report',
    customerInvoicesReportTitle: 'Customer Invoices Report',
    deliveryReportTitle: 'Delivery Report',
    dailyRevenueReportTitle: 'Daily Revenue Report',
    deliveredReportTitle: 'Delivered Report',
    profitReportTitle: 'Profit Report',
    unpaidArrivedInvoicesTitle: 'Unpaid Arrived Invoices',
    unpaidReceivedInvoicesTitle: 'Unpaid Received Invoices',
    ordersReportTitle: 'Orders Report',
    revenueReportTitle: 'Revenue Report',
    orderStatusReportTitle: 'Order Status Report',
    numberOfOrders: 'Number of Orders',
    numberOfRequests: 'Number of Requests',
    totalRequests: 'Total Requests',
    totalBuy: 'Total Buy',
    totalExpenses: 'Total Expenses',
    totalSales: 'Total Sales',
    totalGained: 'Total Gained',
    staffMember: 'Staff Member',
    paymentStatus: 'Payment Status',
    count: 'Count',
    paid: 'Paid',
    transportation: 'Transportation',
    totalCost: 'Total Cost',
    net: 'Net',
    totalRevenue: 'Total Revenue',
    orderCount: 'Order Count',
    request: 'Request',
    exchangeDifference: 'Exchange Difference',
    shippingCost: 'Shipping Cost',
    deliveryIqd: 'Delivery IQD',
    totalGain: 'Total Gain',
    apply: 'Apply',
    printReport: 'Print Report',
    pleaseSelectFromToDate: 'Please select From Date and To Date',
    failedToLoadReport: 'Failed to load report',
    pleaseSelectStatusFromToDate: 'Please select a status, From Date and To Date',
    failedToLoadInvoices: 'Failed to load invoices',
    customerWhoPlacedOrders: 'Customer who placed the order(s)',
    orderCountSubLabelSuffix: '= orders with the selected status, placed by this customer in period',
    periodColon: 'Period:',
    acrossAllCustomers: 'across all customers',
    notPaidHeader: 'Not-Paid',
    notPaidSubLabel: 'Invoices with paid amount = 0',
    partialPaidHeader: 'Partial-Paid',
    partialPaidSubLabel: 'Invoices with 0 < paid < total',
    paidSubLabel: 'Invoices with paid ≥ total',
    equalsInvoiceCount: '= invoice count',
    equalsSigmaInvoiceAmount: '= Σ invoice amount',
    equalsSigmaAmountPaid: '= Σ amount paid',
    allCustomersOption: 'All Customers',
    telColonPrefix: 'Tel: ',
    totalShippingCardTitle: 'Total Shipping',
    equalsSigmaShippingCost: '= Σ shipping cost of orders delivered in period',
    totalShipzoneFeeCardTitle: 'Total Shipzone Fee',
    equalsSigmaShipzoneServiceFee: '= Σ ShipZone service fee of orders delivered in period',
    totalOrders: 'Total Orders',
    grandTotal: 'Grand Total',
    orderStatusStageHint: 'Order status/stage',
    equalsCountOrdersWithStatus: '= count of orders with this status',
    equalsSigmaOrderAmount: '= Σ order amount',
    qtyShipTotalPerCountryHint: 'Qty = N; Ship = Σ shipping (S); Total = Σ amount (A) for this country',
    requestsGroupedByCountryHint: 'Requests grouped by destination country',
    ordersGroupedByCountryHint: 'Orders grouped by destination country',
    equalsCountBuyRequestsInCountry: '= count of buy requests in this country',
    equalsSigmaOrderAmountPreDiscount: '= Σ order amount (pre-discount)',
    equalsSigmaDiscountApplied: '= Σ discount applied',
    groupedByTransportationMethodHint: 'Grouped by transportation method',
    equalsCountOrdersUsingTransportation: '= count of orders using this transportation',
    equalsSigmaOrderCostPreDiscount: '= Σ order cost (pre-discount)',
    equalsSigmaRevenueCollected: '= Σ revenue collected for this transportation',
    sigmaDeliveriesSigmaIqdHint: 'Σ deliveries, Σ IQD',
    equalsCountOrdersInCountry: '= count of orders in this country',
    equalsSigmaOrderAmountForCountry: '= Σ order amount for this country',
    employeeWhoRecordedExpenseHint: 'Employee who recorded the expense',
    equalsSigmaExpenseAmountByStaff: '= Σ expense amount recorded by this staff member',
    sigmaAAcrossAllStaffHint: 'ΣA across all staff',
    accountStatusActiveInactiveHint: 'Account status: Active / Inactive',
    equalsCustomersWithStatusInPeriod: '= customers with this status, registered in period',
    totalRegistered: 'Total Registered',
    invoiceStatusHint: 'Invoice status: Not Paid / Partial / Paid',
    equalsInvoicesWithStatus: '= invoices with this status',
    totalShipmentCardTitle: 'Total Shipment',
    totalTaxCardTitle: 'Total Tax',
    invoiceShipmentCardTitle: 'Invoice Shipment',
    netIncomeCardTitle: 'Net Income',
    equalsSigmaShipmentCost: '= Σ shipment cost',
    equalsSigmaShipzoneFeeCard: '= Σ ShipZone fee',
    equalsSigmaTaxCollected: '= Σ tax collected',
    equalsSigmaShipmentAmountInvoiced: '= Σ shipment amount invoiced to customers',
    equalsSigmaRefundedAmountCard: '= Σ refunded amount',
    equalsSigmaBusinessExpenses: '= Σ business expenses',
    equalsRevenueAfterRefundsFeesBeforeExpenses: '= revenue after refunds/fees, before expenses',
    orderDateHint: 'Order date',
    orderRequestIdHint: 'Order / request ID',
    equalsItemPriceLocalCurrency: '= item price in local currency',
    currencyOfPHint: 'Currency of P (red = $, blue = other)',
    equalsUnitsOnOrder: '= units on this order',
    equalsBuyCostUsd: '= buy cost in USD',
    equalsPerUnitExchangeMargin: '= per-unit exchange margin; × Q when Q > 1',
    equalsPerUnitShippingCost: '= per-unit shipping cost; × Q when Q > 1',
    equalsDeliveryFeeIqd: '= delivery fee in IQD',
    equalsRowGainApprox: '= this row\'s gain ≈ (B + C) × Q',
    totalRevenueAcrossRowsHint: 'ΣB·Q, ΣC·Q, ΣD, ΣE across all rows',
    totalRevenueFooterLabel: 'TOTAL REVENUE:',
    businessExpensesFooterLabel: 'Business Expenses:',
    equalsSigmaBusinessExpensesInPeriod: '= Σ business expenses in period',
    netGainAfterExpensesFooterLabel: 'NET GAIN (after expenses):',
    equalsCountOrdersInPeriod: '= count of orders in period',
    equalsSigmaPurchaseBuyCost: '= Σ purchase/buy cost',
    equalsSigmaSalesRevenue: '= Σ sales revenue'
  },
  mobileApp: {
    aboutAppSectionTitle: 'About App Section',
    helpCenterSectionTitle: 'Help Center (FAQ) Section',
    homeSliderTitle: 'Home Slider (App)',
    addNewHomeSliderButton: 'Add New Home Slider',
    homeBannerTitle: 'Mobile Home Banner (App)',
    popularWebsiteTitle: 'Popular Website (App)',
    updatePopularWebsiteTitle: 'Update Popular Website',
    addNewPopularWebsiteTitle: 'Add New Popular Website',
    globalWebsiteGroupTitle: 'Global Website Group (App)',
    websitesAppTitle: 'Websites (App)',
    addNewGlobalWebsiteButton: 'Add New Global Website',
    updateGlobalWebsiteTitle: 'Update Global Website',
    uploadLogo: 'Upload logo',
    forceUpdateTitle: 'Force Update',
    linksTitle: 'Links',
    ourAddressTitle: 'Our Address',
    updateOurAddressTitle: 'Update Our Address',
    addNewOurAddressTitle: 'Add New Our Address',
    customerAlreadyInList: 'Customer already in the list',
    pleaseSelectCustomer: 'Please select customer',
    pleaseEnterTitle: 'Please enter title',
    pleaseEnterBody: 'Please enter body'
  },
  admin: {
    couponsTitle: 'Coupons',
    editPercentageTooltip: 'Edit percentage',
    giveToCustomerTooltip: 'Give to customer',
    onceDeletedCouponWarning: 'Once deleted, you will not be able to return this coupon!',
    orderLogTitle: 'Order Log',
    viewStaffTooltip: 'View Staff',
    viewOrderTooltip: 'View Order',
    viewCustomerTooltip: 'View customer',
    activityLogTitle: 'Activity Log',
    shipZoneFeePricesTitle: 'ShipZone fee prices',
    suppliersTitle: 'Suppliers',
    rolesTitle: 'Roles',
    assignPermissionTooltip: 'Assign permission',
    settingsTitle: 'Settings',
    securitySection: 'Security',
    profileSection: 'Profile',
    onlinePaymentSection: 'Online Payment',
    staleOrdersSection: 'Stale Orders',
    requireSecretKeyLabel: 'Require secret key for sensitive pages',
    lockFullNameEditLabel: "Lock full name edit (mobile) — once a customer's first/last name is set, they can no longer change it from the mobile app",
    allowChangingCanceledStatusLabel: 'Allow changing status of canceled orders (turn off to lock canceled orders from further status changes)',
    autoCreateShippingInvoicesLabel: "Auto-create shipping invoices for shipped orders on credit top-up (orders always get an invoice at approval, and a top-up always pays down any invoice that already exists, either way; this only controls whether a new FIB/QI/office top-up also proactively creates/combines an invoice for already-shipped orders that don't have one yet, or waits for staff to do that manually via Generate Invoice)",
    enableOnlinePaymentLabel: 'Enable online payment (FIB, QiCard, FastPay, ZainCash) for add balance and order payment — turn off to block all online payment methods app-wide. Cash on Delivery is never affected by this setting.',
    fibCommissionRateLabel: 'FIB commission rate (%)',
    qiCommissionRateLabel: 'QI Card commission rate (%)',
    autoCancelStaleOrdersLabel: 'Auto-cancel orders stuck in New Order or Processed Order',
    hoursBeforeAutoCancelLabel: 'Hours before auto-cancel',
    notifyProcessedOrdersLabel: 'Notify customers about Processed Orders awaiting their approval (sent in batches)',
    hoursBeforeReminderLabel: 'Hours before reminder notification',
    securitySectionDesc: 'Controls access to sensitive admin pages.',
    profileSectionDesc: 'Controls how customers can edit their profile from the mobile app.',
    ordersSectionDesc: 'Status-change rules and invoice generation for orders.',
    onlinePaymentSectionDesc: "FIB/QiCard/FastPay/ZainCash availability, and the commission added on top of a customer's amount when they add balance through FIB or QI Card. Order payments are never charged a commission.",
    staleOrdersSectionDesc: "Auto-cancellation for orders left sitting in New Order or Processed Order, and reminder notifications for Processed Orders the customer hasn't approved yet.",
    fibCommissionRateHint: 'Added on top of the amount when a customer adds balance via FIB. Does not affect order payments.',
    qiCommissionRateHint: 'Added on top of the amount when a customer adds balance via QI Card. Does not affect order payments.',
    hoursBeforeAutoCancelHint: "How long an order can sit in New Order or Processed Order before it's automatically canceled.",
    hoursBeforeReminderHint: "How long a Processed Order can wait for customer approval before a reminder notification is sent.",
    settingsUpdatedSuccessfully: 'Settings updated successfully',
    pleaseUpdateAnything: 'Please update anything',
    citiesTitle: 'Cities',
    governoratesTitle: 'Governorates',
    cancellationRefundReasonsTitle: 'Cancellation and Refund Reasons',
    deleteSubscriptionTooltip: 'Delete Subscription',
    subscriptionPricingTitle: 'Subscription Pricing',
    pleaseSelectAtLeastOneUserSubscriptionToDelete: 'Please select at least one user subscription to delete',
    editOrderTypeTooltip: 'Edit Order Type',
    deleteOrderTypeTooltip: 'Delete Order Type',
    deleteOrderTypeConfirm: 'Delete Order Type: {name}?',
    savedTitle: 'Saved'
  },
  customer: {
    myOrdersTitle: 'My Orders',
    orderDetailTooltip: 'Order Detail',
    editOrderTooltip: 'Edit Order',
    addTrackNumberTooltip: 'Add track number',
    archiveThisOrderTooltip: 'Archive This Order',
    onceArchivedWarning: 'Once archived, you will not be able to return this order to this step!',
    archivedTitle: 'Archived',
    orderCanceledLabel: 'Order Canceled:',
    refundReason: 'Refund reason',
    processNote: 'Process Note',
    processNoteImage: 'Process Note Image',
    trackNo: 'Track No',
    link: 'Link',
    couponPercentage: 'Coupon percentage',
    color: 'Color',
    deliveryType: 'Delivery type',
    deliveryTypeUpdatedSuccessfully: 'Delivery type updated successfully',
    repackage: 'Repackage',
    hold: 'Hold',
    otherService: 'Other Service',
    quantityCharge: 'Quantity charge',
    itemPrice: 'Item price',
    internationalTax: 'International Tax',
    itemType: 'Item type',
    addItemTypeTitle: 'Add Item Type',
    itemAddedSuccessfully: 'Item added successfully',
    shippingPrice: 'Shipping Price',
    discountedShippingPrice: 'Discounted Shipping Price',
    insurance: 'Insurance',
    repackagePrice: 'Repackage Price',
    holdPrice: 'Hold Price',
    otherServicePrice: 'Other Service Price',
    handlingFee: 'Handling Fee',
    itemWeightLb: 'Item weight(LB)',
    archivedOrdersTitle: 'Archived Orders',
    orderDate: 'Order Date',
    otherServiceSpecify: 'Other service (please specify)',
    couponCodeValidation: 'This field must contain a Coupon Code',
    amountInIqdIs: 'Amount in IQD is:',
    scanThisQrCode: 'Scan this QrCode',
    payWithLabel: 'Pay with',
    minimumAmountHint: 'Minimum amount ($0.2) or (IQD250)',
    nextButton: 'Next',
    enterCodeManuallyHint: 'or enter this code manually',
    tryAgainButton: 'Try Again',
    chargeYourAccount: 'Charge your account',
    selectPaymentMethod: 'Select payment method',
    qiPaymentChecking: 'Checking your QI payment…',
    qiPaymentSuccess: 'Payment received — your balance has been updated.',
    qiPaymentPending: 'Your QI payment is still being processed. Your balance will update automatically once it is confirmed.',
    qiPaymentCancelled: 'The QI payment was cancelled. No money was taken.',
    qiPaymentFailed: 'The QI payment failed. Please try again or choose another payment method.',
    cancelOrderTitle: 'Cancel Order',
    cancelReasonLabel: 'Cancel reason',
    deliverBranchLabel: 'Deliver Branch',
    approvedTitle: 'Approved',
    addAddressTitle: 'Add Address',
    addTrackNumberTitle: 'Add Track Number',
    trackNumberAddedSuccessfully: 'Track number added successfully',
    checkRateTitle: 'Check Rate',
    originCountry: 'Origin Country',
    weightPerPackage: 'Weight Per Package',
    length: 'Length',
    width: 'Width',
    height: 'Height',
    destinationCountry: 'Destination Country',
    documentOption: 'Document',
    noneDocumentOption: 'None Document',
    showRateButton: 'Show Rate',
    invoicesTitle: 'Invoices',
    partialRefundInvoiceTitle: 'Partial Refund Invoice',
    invoiceDate: 'Invoice Date',
    description: 'Description',
    exportOrdersTitle: 'Export Orders',
    exportOrderDetailTitle: 'Export Order Detail',
    orderInfoSection: 'Order Info',
    priceInfoSection: 'Price Info',
    delivery: 'Delivery',
    statusInfoSection: 'Status Info',
    orderedAt: 'Ordered At',
    canceledAt: 'Canceled At',
    canceledBy: 'Canceled By',
    approvedAt: 'Approved At',
    approvedBy: 'Approved By',
    refundedAt: 'Refunded At',
    refundedBy: 'Refunded By',
    sentAt: 'Sent At',
    receivedAt: 'Received At',
    receivedBy: 'Received By',
    receiverInfoSection: 'Receiver Info',
    zipCode: 'ZIP Code',
    productDescription: 'Product Description',
    receiverDetail: 'Receiver Detail',
    destination: 'Destination',
    updateExportOrderTitle: 'Update Export Order',
    addExportOrderTitle: 'Add Export Order',
    requestExportOrderTitle: 'Request Export Order',
    updateExportOrderTitleWithNumber: 'Update Export Order {number}',
    requestedSuccessfullyMessage: 'Requested successfully',
    requestButton: 'Request',
    updateOrderTitleWithNumber: 'Update Order {number}',
    requestOrderTitle: 'Request Order',
    dimensionsPerPackageLabel: 'Dimensions Per Package',
    cancelNote: 'Cancel Note',
    approveOrderTooltip: 'Approve Order',
    volumeL: 'Volume (L)',
    volumeW: 'Volume (W)',
    volumeH: 'Volume (H)',
    fullyRefundedBadge: 'Fully Refunded',
    partiallyRefundedBadge: 'Partially Refunded',
    partiallyRefundedAt: 'Partially Refunded At',
    partiallyRefundedBy: 'Partially Refunded By',
    totalRefundedAmount: 'Total Refunded Amount',
    addingBalanceWithMethod: 'Adding Balance with {method}',
    addingBalanceFromOffice: 'Adding Balance from ShipZone Office',
    returningBalanceFromOffice: 'Returning Balance from ShipZone Office',
    totalAddLabel: 'Total Add',
    totalCashBackLabel: 'Total CashBack',
    generalTotalLabel: 'General Total',
    totalSubLabel: 'Total Sub',
    totalRefundLabel: 'Total Refund',
    orderNoHeading: 'ORDER NO. {id}',
    expectedDateLabel: 'Expected Date',
    requestedStepLabel: 'Requested',
    deliveryStatusPrefix: 'Delivery {status}',
    cannotUpdateTrackNumber: 'You cannot update track number',
    addressIsRequired: 'Address is required',
    orderRequestedSuccessfully: 'Order Requested successfully'
  },
  finance: {
    banksTitle: 'Banks',
    addBankTitle: 'Add Bank',
    updateBankTitle: 'Update Bank',
    bankAddedSuccessfully: 'Bank added successfully',
    bankUpdatedSuccessfully: 'Bank updated successfully',
    filterByBank: 'Filter by Bank',
    filterByStatus: 'Filter by Status',
    filterByType: 'Filter by Type',
    bankTransactionsTitle: 'Bank Transactions',
    totalAmount: 'Total Amount',
    transactionDetailTitle: 'Transaction Detail',
    transactionInfoSection: 'Transaction Info',
    classificationSection: 'Classification',
    sourceInfoSection: 'Source Info',
    datesAndStaffSection: 'Dates & Staff',
    couldNotUpdateVerificationStatus: 'Could not update verification status',
    pleaseSelectTransactionsToVerify: 'Please select transactions to verify',
    verifySelectedTransactionsConfirm: 'Verify {count} selected transactions?',
    transactionsVerifiedSuccessfully: 'Transactions verified successfully',
    pleaseTryAgain: 'Please try again',
    statusPaid: 'Paid',
    statusUnpaid: 'Unpaid',
    statusPending: 'Pending',
    statusCancel: 'Cancel',
    statusRefunded: 'Refunded',
    statusPartialRefunded: 'Partial Refunded',
    typeOrder: 'Order',
    typeMoneyTransfer: 'Money Transfer',
    typeExpense: 'Expense',
    typeCreditInvoice: 'Credit Invoice',
    typeCashBack: 'Cash Back',
    typeDigitalPayment: 'Digital Payment',
    exchangeRatesTitle: 'Exchange Rates',
    addExchangeRateTitle: 'Add Exchange Rate',
    updateExchangeRateTitle: 'Update Exchange Rate',
    exchangeRateAddedSuccessfully: 'Exchange rate added successfully',
    exchangeRateUpdatedSuccessfully: 'Exchange rate updated successfully',
    currencyRatesTitle: 'Currency Rates',
    addCurrencyRateTitle: 'Add New Currency Rate',
    updateCurrencyRateTitle: 'Update Currency Rate',
    sellRateLabel: '{code} Sell Rate ({code} per 1 USD)',
    buyRateLabel: '{code} Buy Rate (bank rate)',
    expensesTitle: 'Expenses',
    addExpenseTitle: 'Add New Expense',
    updateExpenseTitle: 'Update Expense',
    thereIsAnError: 'There is an error',
    expenseFooterNote: 'Each line is one expense status (sums over <strong>all</strong> matching rows, every page). The table above is only the current page — use pagination or raise "per page" to see unpaid/cash rows. Add paid + unpaid + cash to match Capital "Expenses" when date range matches the Capital book period.',
    received: 'Received',
    notReceived: 'Not Received',
    pleaseSelectAtLeastOneExpense: 'Please select at least one expense!',
    markAllSelectedExpensesReceivedConfirm: 'This will mark all selected expenses as received.',
    somethingWentWrong: 'Something went wrong!',
    supplierInvoiceNumberLabel: 'Supplier Invoice Number',
    expenseTypesTitle: 'Expense Types',
    addExpenseTypeTitle: 'Add New Expense Type',
    updateExpenseTypeTitle: 'Update Expense Type',
    capitalTitle: 'Capital',
    refresh: 'Refresh',
    initializeCapital: 'Initialize capital',
    depositWithdraw: 'Deposit / Withdraw',
    bookSummary: 'Book summary ({from} to {to})',
    initializedCapital: 'Initialized capital',
    totalDeposits: 'Total deposits',
    totalWithdraws: 'Total withdraws',
    revenueIncome: 'Revenue (income)',
    netCapitalBook: 'Net capital (book): {amount}',
    capitalMovements: 'Capital movements',
    withdraw: 'Withdraw',
    deposit: 'Deposit',
    saved: 'Saved',
    couldNotSave: 'Could not save',
    amountUsdLabel: 'Amount (USD) *',
    depositOrWithdrawTitle: 'Deposit or withdraw',
    adjustsCapitalBookNote: 'Adjusts the capital book only. Bank balances in the system are not changed.',
    noteOptionalLabel: 'Note (optional)',
    noteReasonPlaceholder: 'Reason or reference for this movement',
    noteShownHint: 'If provided, shown in the movements list.',
    depositAddToCapitalBook: 'Deposit (add to capital book)',
    withdrawSubtractFromCapitalBook: 'Withdraw (subtract from capital book)',
    enterValidAmountError: 'Enter a valid amount (at least 0.01).',
    moneyTransfersTitle: 'Money Transfers',
    transferMoneyTitle: 'Transfer Money',
    doneSuccessfully: 'Done successfully'
  },
  login: {
    brandName: 'Las Shopping',
    welcomeBack: 'Welcome Back!',
    signInToContinue: 'Sign in to continue',
    phoneNumber: 'Phone Number',
    password: 'Password',
    loginButton: 'Login',
    noAccount: "Don't have an account?",
    signUp: 'Sign up',
    adminLoginTitle: 'Admin Login',
    adminSignInSubtitle: 'Sign in to your staff account',
    email: 'Email'
  },
  signup: {
    createAccountTitle: 'Create Account',
    step1Hint: 'Enter your phone number to receive a verification code.',
    sendCodeButton: 'Send Code',
    alreadyHaveAccount: 'Already have an account?',
    signInLink: 'Sign in',
    otpSentHintPrefix: 'Enter the verification code sent to',
    verificationCodeLabel: 'Verification Code',
    backButton: '← Back',
    verifyButton: 'Verify',
    step3Hint: 'Complete your profile to finish registration.',
    fullNameHint: 'Enter at least first and last name',
    dateOfBirthLabel: 'Date of Birth',
    passwordMinCharsHint: 'Minimum 6 characters',
    emailOptionalLabel: 'Email (optional)',
    genderOptionalLabel: 'Gender (optional)',
    maleOption: 'Male',
    femaleOption: 'Female',
    deliveryAddressOptional: 'Delivery Address',
    optionalLabel: '(optional)',
    addressSectionHint: 'Helps speed up future orders',
    addressTypeLabel: 'Address Type',
    houseNumberLabel: 'House Number',
    floorOptionalLabel: 'Floor (optional)',
    streetLabel: 'Street',
    buildingNameLabel: 'Building Name',
    apartmentNumberLabel: 'Apartment Number',
    floorLabel: 'Floor',
    companyLabel: 'Company',
    addressPhoneNumberOptional: 'Address Phone Number (optional)',
    additionalDirectionsOptional: 'Additional Directions (optional)',
    addressLabelHint: 'Address Label (e.g. Home, Work)',
    createAccountButton: 'Create Account',
    houseType: 'House',
    apartmentType: 'Apartment',
    officeType: 'Office',
    validPhoneRequiredError: 'Please enter a valid phone number',
    failedToSendCodeError: 'Failed to send code',
    verificationCodeRequiredError: 'Please enter the verification code',
    verificationFailedError: 'Verification failed',
    fullNameRequiredError: 'Full name is required',
    dobRequiredError: 'Date of birth is required',
    passwordMinLengthError: 'Password must be at least 6 characters',
    confirmPasswordRequiredError: 'Please confirm your password',
    passwordsDoNotMatchError: 'Passwords do not match',
    validEmailRequiredError: 'Please enter a valid email address',
    addressTypeRequiredError: 'Address type is required',
    addressLabelRequiredError: 'Address label is required (e.g. Home)',
    welcomeTitle: 'Welcome!',
    accountCreatedSuccessfully: 'Your account has been created successfully.',
    registrationFailedTitle: 'Registration Failed',
    verifyAccountTitle: 'Verify your account',
    nextButton: 'Next',
    congratulationsTitle: 'Congratulations!',
    accountVerifiedSuccessfully: 'Your account has been verified successfully.',
    backToHomeButton: 'Back To Home'
  },
  statistics: {
    fromDateLabel: 'From Date',
    toDateLabel: 'To Date',
    chartTypeLabel: 'Chart Type',
    barChartOption: 'Bar Chart',
    pieChartOption: 'Pie Chart',
    doughnutChartOption: 'Doughnut Chart',
    lineChartOption: 'Line Chart',
    applyButton: 'Apply',
    loadingStatisticsText: 'Loading statistics...',
    selectDateRangeHint: 'Select a date range and click Apply to load charts.',
    noDataFoundHint: 'No data found for the selected date range.',
    fullScreenTitle: 'Full screen',
    topCustomersByOrderCount: 'Top 10 Customers by Order Count',
    topCustomersByRevenue: 'Top 10 Customers by Revenue ($)',
    revenueUsdLabel: 'Revenue ($)',
    topWebsitesByOrders: 'Top 10 Websites by Orders',
    topWarehousesByOrders: 'Top 10 Warehouses by Orders',
    topProductsByOrders: 'Top 10 Products by Orders',
    topBrandsByOrders: 'Top 10 Brands by Orders',
    orderStatusDistribution: 'Order Status Distribution',
    topItemTypesByOrders: 'Top 10 Item Types by Orders',
    monthlyOrderTrend: 'Monthly Order Trend',
    pleaseSelectFromToDate: 'Please select From Date and To Date.',
    failedToLoadStatistics: 'Failed to load statistics.'
  },
  linkRules: {
    updateLinkRuleTitle: 'Update Link Rule',
    addNewLinkRuleTitle: 'Add New Link Rule',
    nameHint: "Admin label, e.g. 'Trendyol'",
    testUrlLabel: 'Test URL',
    testUrlHint: 'Paste a real example product URL from this site. Domain and the preview below are derived from it.',
    domainHint: 'Matched as a substring against the URL host, e.g. trendyol.com',
    shortLinkCheckboxLabel: 'This is a short link (redirects, e.g. ty.gl)',
    searchByNameOrDomainPlaceholder: 'Search by name or domain...',
    shortLinkColumn: 'Short Link',
    priorityColumn: 'Priority',
    resolveButton: 'Resolve',
    resolvesToLabel: 'Resolves to:',
    detectedAsProductPage: '✅ Detected as a product page',
    notDetectedAsProductPage: '❌ Not detected as a product page',
    previewExtractedNameLabel: 'Preview extracted name:',
    hideAdvancedOptions: 'Hide advanced options',
    advancedOptionsHint: 'Advanced options (only needed if the preview above is wrong)',
    productPageMatchTypeLabel: 'Product page match type',
    productPagePatternLabel: 'Product page pattern',
    productPagePatternHint: 'Path substring (contains) or regex',
    excludePathPrefixesLabel: 'Exclude path prefixes',
    excludePathPrefixesHint: 'Comma-separated, overrides the default cart/checkout/etc. exclusion list for this domain',
    nameExtractionTypeLabel: 'Name extraction type',
    nameExtractionPatternLabel: 'Name extraction pattern',
    nameExtractionPatternHint: 'Regex with one capture group, or a query param key',
    nameCleanupRegexLabel: 'Name cleanup regex',
    nameCleanupRegexHint: 'Optional: extra trailing-suffix stripper applied after extraction',
    priorityLabel: 'Priority',
    priorityHint: 'Lower runs first when multiple rules could match',
    notesLabel: 'Notes',
    containsPathSubstringOption: 'Contains (path substring)',
    regexOption: 'Regex',
    regexCaptureGroupOption: 'Regex (capture group 1)',
    queryParameterOption: 'Query parameter',
    couldNotResolveUrl: 'Could not resolve this URL'
  },
  qrLabels: {
    driverLabel: 'Driver',
    productLabel: 'Product',
    printLabelDriverButton: 'Print Label (Driver)',
    printLabelOrderIdButton: 'Print Label (Order ID)',
    failedToGenerateQrCode: 'Failed to generate QR code',
    failedToAdvanceToIntShipment: 'Failed to advance orders to Int Shipment'
  },
  datatable: {
    newOrderButton: 'New Order',
    reloadTableButton: 'Reload Table',
    toggleButtonDisplayTooltip: 'Show/hide button labels',
    exportButton: 'Export',
    prepareToPrintButton: 'Prepare to print',
    fastPaymentButton: 'Fast Payment',
    mergeAndPrintButton: 'Merge & Print',
    receiveButton: 'Receive',
    unreceiveButton: 'Unreceive',
    printReceiveButton: 'Print Receive',
    outOfficeButton: 'Out Office',
    addNewButton: 'Add New',
    generateQrCodeButton: 'Generate QrCode',
    generateInvoiceButton: 'Generate Invoice',
    attachToDeliveryButton: 'Attach to Delivery',
    changeStatusButton: 'Change Status',
    deliverySummaryButton: 'Delivery Summary',
    unclearButton: 'Unclear',
    reloadShortLabel: 'Reload',
    qrCodeShortLabel: 'QR Code',
    invoiceShortLabel: 'Invoice',
    statusShortLabel: 'Status',
    summaryShortLabel: 'Delivery',
    prepareToPrintShortLabel: 'Print',
    fastPaymentShortLabel: 'Fast Pay',
    mergeAndPrintShortLabel: 'Merge',
    printReceiveShortLabel: 'Print Rcv',
    sendAllToCustomerShortLabel: 'Send All',
    secondInvoiceShortLabel: '2nd Invoice',
    generateSecondInvoiceButton: 'Generate 2nd Invoice',
    deliveryInvoiceButton: 'Delivery Invoice',
    sendToWarehouseButton: 'Send to warehouse',
    sendToPendingShipmentButton: 'Send to Pending Shipment',
    sendAllToPendingShipmentButton: 'Send all to Pending Shipment',
    sendToShipmentButton: 'Send to Shipment',
    sendAllToShipmentButton: 'Send all to Shipment',
    newShiponlyButton: 'New Shiponly',
    sendToPendingToBranchButton: 'Send to Pending To Branch',
    sendToBranchButton: 'Send to Branch',
    sendAllToBranchButton: 'Send All To Branch',
    sendToBranchDeliveryButton: 'Send to Branch Delivery',
    sendToCustomerButton: 'Send to Customer',
    sendAllToCustomerButton: 'Send All To Customer',
    addStaffButton: 'Add Staff',
    approveAllShiponlyButton: 'Approve All Shiponly',
    bulkOrdersButton: 'Bulk Orders',
    sendAllToProcessButton: 'Send All To Process',
    cashBackButton: 'Cash Back',
    addCreditButton: 'Add Credit',
    addWarehouseButton: 'Add Warehouse',
    addCustomerButton: 'ADD Customer',
    generateCouponButton: 'Generate Coupon',
    addBankButton: 'Add Bank',
    addSupplierButton: 'Add Supplier',
    addExpenseTypeButton: 'Add Expense Type',
    addNewExpenseButton: 'Add New Expense',
    addNewCityButton: 'Add New City',
    updateCityTitle: 'Update City',
    updateAboutTitle: 'Update About',
    addNewAboutTitle: 'Add New About',
    updateSupplierTitle: 'Update Supplier',
    addNewSupplierTitle: 'Add New Supplier',
    addGovernorateButton: 'Add Governorate',
    addNewReasonButton: 'Add New Reason',
    updateReasonTitle: 'Update Reason',
    addNewAboutAppButton: 'Add New About App',
    addNewHelpCenterButton: 'Add New Help Center',
    addNewRoleButton: 'Add New Role',
    updateRoleTitle: 'Update Role',
    deleteSelectedSubscriptionButton: 'Delete Selected Subscription',
    addNewCustomerSubscriptionButton: 'Add New Customer Subscription',
    permanentlyDeleteSelectedOrdersButton: 'Permanently Delete Selected Orders',
    addNewBranchButton: 'Add New Branch',
    branchesTitle: 'Branches',
    updateBranchTitle: 'Update Branch',
    addMoneyButtonDefault: 'Add Money',
    transferMoneyButton: 'Transfer Money',
    addExchangeRateButton: 'Add Exchange Rate',
    requestDeliveryButton: 'Request Delivery',
    applyFilterTooltip: 'Apply Filter',
    cancelFilterTooltip: 'Cancel Filter',
    showHideColumnsLabel: 'Show/Hide Columns',
    pleaseSelectWarehouseHint: 'Please select warehouse',
    pleaseSelectBothDatesError: 'Please select both date!',
    chooseOption: 'Choose',
    orderOption: 'Order',
    usaOption: 'USA',
    chinaOption: 'China',
    uaeOption: 'UAE',
    partialReceivedOption: 'Partial Received'
  },
  printLogs: {
    title: 'Print Logs',
    subtitle: 'Track all printed invoices',
    printButton: 'Print',
    printAllButton: 'Print all',
    fromLabel: 'From',
    toLabel: 'To',
    typeLabel: 'Type',
    allTypesOption: 'All Types',
    secondShippingOption: '2nd Shipping',
    printedByLabel: 'Printed By',
    allStaffOption: 'All Staff',
    filterButton: 'Filter',
    todayButton: 'Today',
    totalEntries: 'Total Entries',
    totalAmountLabel: 'Total Amount',
    firstPrints: 'First Prints',
    reprints: 'Reprints',
    loadingLogsText: 'Loading logs...',
    noPrintsFoundTitle: 'No Prints Found',
    noPrintsFoundBetween: 'No invoices were printed between {from} and {to}.',
    timeColumn: 'Time',
    reprintBadge: 'Reprint ×{count}',
    firstPrintBadge: 'First Print',
    viewOnlyBadge: 'View Only',
    viewOnlyTooltip: 'Printed from the invoice View button — not proof of payment',
    deliveryPrintTooltip: "Printed via the Delivery button — attached to the customer's delivery request",
    saveAndViewBadge: 'Save & View',
    saveAndViewTooltip: 'Printed via Save and view — an official copy of the saved invoice',
    totalLabel: 'Total',
    printPageTitle: 'Print Logs — {from} to {to}'
  },
  profit: {
    title: 'Profit',
    totalInternationalShipment: 'Total International Shipment',
    totalShippingInvoiceShipment: 'Total Shipping Invoice Shipment',
    totalLocalTax: 'Total Local Tax',
    totalFee: 'Total Fee',
    totalRefund: 'Total Refund',
    totalIncome: 'Total Income',
    totalExpense: 'Total Expense'
  },
  driverDeliver: {
    loadingOrderDetails: 'Loading order details...',
    orderMovedTitle: 'Order Moved to Branch Delivery!',
    orderMovedMessage: 'Order #{id} has been moved to Branch Delivery.',
    alreadyAtBranchTitle: 'Already at Branch',
    alreadyAtBranchMessage: 'This order has already been moved to Branch Delivery.',
    cannotProcessTitle: 'Cannot Process',
    wrongStatusMessage: 'This order is not in International Shipment stage. Current status:',
    orderNumberLabel: 'Order #{id}',
    naLabel: 'N/A',
    areaLabel: 'Area',
    houseBuildingLabel: 'House / Building',
    deliveryPhoneLabel: 'Delivery Phone',
    tapToMoveButton: 'Tap to Move to Branch Delivery',
    processingButton: 'Processing...',
    unknownStatus: 'Unknown',
    failedToLoadOrder: 'Failed to load order',
    failedToLoadOrderDetails: 'Failed to load order details',
    failedToProcessOrder: 'Failed to process order'
  },
  addEditGovernorate: {
    updateTitle: 'Update Governorate',
    addTitle: 'Add New Governorate',
    governorateNameLabel: 'Governorate Name',
    governorateNameArLabel: 'Governorate Name (Arabic)',
    governorateNameKuLabel: 'Governorate Name (Kurdish)'
  },
  cashBack: {
    title: 'Credit Cash Back',
    cashedBackSuccessfully: 'Credit cashed back successfully',
    amountMoreThanCreditError: 'Cash back amount is more than customer credit',
    editTitle: 'Edit Cash Back',
    updatedSuccessfully: 'Cash back updated successfully'
  },
  generateCoupon: {
    couponsGeneratedSuccessfully: 'Coupons Generated Successfully',
    couponsUpdatedSuccessfully: 'Coupons Updated Successfully',
    numberOfCouponLabel: 'Number of coupon',
    discountPercentageLabel: 'Discount percentage',
    expireDateLabel: 'Expire Date',
    generateButton: 'Generate',
    pleaseDetermineExpireDate: 'Please determine the Expire Date',
    expireDateMustBeGreaterThanToday: 'Expire Date should be greater than today'
  },
  partialRefundingOrder: {
    title: 'Partial Refund',
    orderTotalAmountLabel: 'The order Total amount is ${amount}'
  },
  addEditOrderCase: {
    updateTitle: 'Update Order Case',
    addTitle: 'Add New Order Case',
    orderIdColon: 'Order ID:',
    imagesTitle: 'Order Case Images'
  },
  addEditNotFoundOrder: {
    updateTitle: 'Update Not Found Order',
    addTitle: 'Add New Not Found Order',
    updatedTitle: 'Updated'
  },
  adminCancelOrder: {
    orderCanceledSuccessfully: 'Order canceled successfully',
    willAutoRefundPrefix: 'This order has already been purchased. Canceling it will also automatically issue a full refund',
    ofUpToAmount: ' of up to ${amount}',
    willAutoRefundTail: " to the customer's credit balance. The exact amount will account for any prior partial refunds already given.",
    cancelReasonListLabel: 'Cancel reason list',
    cancelReasonEnglishLabel: 'Cancel reason english',
    cancelReasonArabicLabel: 'Cancel reason arabic',
    cancelReasonKurdishLabel: 'Cancel reason kurdish'
  },
  globalWebsiteGroupModal: {
    updateGroupTitle: 'Update Group',
    addNewGroupTitle: 'Add New Group',
    sitesButton: 'Sites'
  },
  recordInvoicePayment: {
    title: 'Record Payment',
    invoiceHashLabel: 'Invoice #',
    walletBalanceCheckboxLabel: 'Customer already has this amount in their wallet balance (e.g. from a FIB/QI/office top-up) — apply it without adding credit again',
    balanceOption: 'Balance',
    availableTitle: 'This customer has {amount} available balance',
    useBalance: 'Use balance',
    unknownSource: 'source not identified',
    balanceHint: '"Balance" never adds money — it pays from what the customer already has.',
    balanceButton: 'Balance',
    payButton: 'Pay'
  },
  addEditUserSubscription: {
    customerSubscriptionTitle: 'Customer Subscription',
    deleteAllSelectedConfirm: 'Delete all selected user subscriptions?'
  },
  orderDeliveryCustomerImages: {
    title: 'Customer Orders & Images',
    noOrdersFound: 'No orders found for this customer.',
    productLabel: 'Product',
    imagesLabel: 'Images',
    notInvoiced: 'Not invoiced'
  },
  viewOrderDates: {
    pendingAnswerDateLabel: 'Pending Answer Date',
    processDateLabel: 'Process Date',
    cancelDateLabel: 'Cancel Date',
    approveDateLabel: 'Approve Date',
    refundDateLabel: 'Refund Date',
    pendingShipmentDateLabel: 'Pending Shipment Date',
    shipmentDateLabel: 'Shipment Date',
    deliveredDateLabel: 'Delivered Date'
  },
  refundingOrder: {
    title: 'Refund Order',
    sendSmsLabel: 'Send SMS',
    orderTotalRemainAmountLabel: 'Order Total remain amount is ${amount}'
  },
  assignPermission: {
    titleWithRole: 'Assign permission to [{role}] role',
    savedSuccessfully: 'Saved successfully',
    checkAllLabel: 'Check all'
  },
  purchaseOrder: {
    titleWithId: 'Purchase Order {id}',
    costBreakdownByWarehouse: 'Cost Breakdown by Warehouse',
    ordersSelectedLabel: '{count} orders selected',
    actualPriceLabel: 'Actual Price',
    actualPriceRequiredError: 'Actual Price is required',
    mustBeValidNumberError: 'Must be a valid number'
  },
  reassignCustomer: {
    reassignCustomerTooltip: 'Reassign Customer',
    chargedToLabel: 'This order is currently charged to',
    pickingDifferentCustomerText: "Picking a different customer below will refund {name}, delete this order's shipping invoice, and charge the selected customer with a new invoice for the same amount (${amount}).",
    newCustomerLabel: 'New Customer* (search by name or phone)',
    telPrefix: ' - Tel: ',
    failedToLoadCustomers: 'Failed to load customers',
    selectedCustomerFallback: 'the selected customer',
    confirmReassignText: "This will refund {name}, delete this order's shipping invoice, and charge {newName} a new invoice for ${amount}. Continue?",
    failedToReassignCustomer: 'Failed to reassign customer'
  },
  createCredit: {
    creditAddedSuccessfully: 'Credit added successfully',
    amountUsdLabel: 'Amount USD',
    amountIqdLabel: 'Amount IQD',
    autoInvoiceLabel: 'Auto-generate invoice for shipped orders with no invoice yet (unchecking this only skips creating a new invoice — this top-up still pays down any invoice that already exists either way)'
  },
  helpCenter: {
    updateTitle: 'Update Help Center',
    questionEnLabel: 'Question (English)',
    questionArLabel: 'Question (Arabic)',
    questionKuLabel: 'Question (Kurdish)',
    answerEnLabel: 'Answer (English)',
    answerArLabel: 'Answer (Arabic)',
    answerKuLabel: 'Answer (Kurdish)',
    isActiveLabel: 'Is Active',
    answerEnRequiredError: 'Answer (English) is required',
    displayLanguageLabel: 'Display Language',
    englishEnOption: 'English (en)',
    arabicArOption: 'Arabic (ar)',
    kurdishKuOption: 'Kurdish (ku)'
  },
  processExportOrder: {
    title: 'Process Export Order',
    orderNoColon: 'Order No.:'
  },
  customerDeliverySummary: {
    title: 'Customer Delivery Summary',
    clearButton: 'Clear',
    loadingAllOrders: 'Loading all matching orders…',
    totalCustomerLabel: 'Total Customer',
    totalOrdersLabel: 'Total Orders',
    requestReceivedLabel: 'Request Received',
    dateReceivedLabel: 'Date Received',
    timeLabel: 'Time',
    confirmClearOrdersText: 'Mark {count} order(s) as cleared? They will no longer appear in this list by default.',
    failedToClearOrders: 'Failed to clear orders'
  },
  adminDashboard: {
    title: 'Dashboard',
    updatedAtLabel: 'Updated {time}',
    refreshButton: 'Refresh',
    loadingDashboardText: 'Loading dashboard...',
    orderIntakeSection: 'Order Intake',
    processingSection: 'Processing',
    fulfillmentSection: 'Fulfillment',
    deliveryCompletionSection: 'Delivery & Completion',
    pendingAnswerLabel: 'Pending Answer',
    processedLabel: 'Processed',
    ordersTodayLabel: 'Orders Today',
    pendingPaymentsLabel: 'Pending Payments',
    purchasedLabel: 'Purchased',
    warehouseDeliveredLabel: 'Warehouse Delivered',
    intShipmentLabel: 'Int. Shipment',
    pendingToBranchLabel: 'Pending to Branch',
    branchDeliveryLabel: 'Branch Delivery',
    deliveredLabel: 'Delivered',
    kurdistanBalance: 'Kurdistan Balance',
    usaBalance: 'USA Balance',
    customersOweUs: 'Customers Owe Us',
    weOweCustomers: 'We Owe Customers',
    supplierLoan: 'Supplier Loan',
    totalCapital: 'Total Capital'
  },
  homeSlider: {
    updateTitle: 'Update Home Slider',
    addTitle: 'Add New Home Slider'
  },
  editOrderCharge: {
    editChargeTooltip: 'Edit Charge',
    editChargeTitle: 'Edit Charge',
    alreadyChargedHint: "This order has already been charged. Changing the total below will automatically debit/credit the customer's balance for the difference.",
    itemPriceUsdLabel: 'Item Price ($)',
    shippingUsdLabel: 'Shipping ($)',
    discountUsdLabel: 'Discount ($)',
    newTotalLabel: 'New Total:',
    wasLabel: '(was ${amount})',
    failedToLoadOrderDetails: 'Failed to load order details',
    increaseWithBalanceText: "Total will increase from ${from} to ${to} (+${diff}). ${diff} will be deducted from the customer's balance. Continue?",
    increaseInsufficientBalanceText: "Total will increase from ${from} to ${to} (+${diff}). The customer's balance may be insufficient — a note will be recorded instead. Continue?",
    decreaseText: "Total will decrease from ${from} to ${to} (-${diff}). ${diff} will be credited back to the customer's balance. Continue?",
    orderUpdatedTitle: 'Order Updated',
    failedToUpdateOrder: 'Failed to update order'
  },
  refundExportOrder: {
    fullRefundTitle: 'Full Refund Export Order',
    partialRefundTitle: 'Partial Refund Export Order',
    refundedSuccessfully: 'Order refunded successfully',
    orderTotalAmountLabel: 'Order Total amount is ${amount}',
    alreadyRefundedLabel: 'Already Refunded: ${amount}',
    moneyAmountLabel: 'Money amount',
    refundNoteLabel: 'Refund note',
    confirmRefundText: 'This will refund ${amount} to the customer\'s credit.',
    validRefundAmountError: 'Please enter a valid refund amount',
    amountExceedsRemainingError: 'Amount cannot exceed remaining amount: ${amount}',
    partialLessThanRemainingError: 'Partial refund must be less than remaining amount: ${amount}',
    refundReasonRequiredError: 'Refund reason is required for full refunds',
    fullRefundProcessedSuccessfully: 'Full refund processed successfully',
    partialRefundProcessedSuccessfully: 'Partial refund processed successfully',
    failedToProcessRefund: 'Failed to process refund'
  },
  secret: {
    greetingHi: 'Hi {name}',
    enterSecretKeyHint: 'To see this section you have to enter your Secret Key',
    dontHaveSecretKey: "Don't have Secret Key?",
    letMeInButton: 'Let me in',
    confirmSecretKeyLabel: 'Confirm Secret key'
  },
  viewOrderUsers: {
    orderedBy: 'Ordered By',
    shipOnlyBy: 'Ship Only By',
    pendingAnsweredBy: 'Pending Answered By',
    processedBy: 'Processed By',
    warehousedBy: 'Warehoused By',
    pendingShippedBy: 'Pending Shipped By',
    shippedBy: 'Shipped By',
    pendingToBranchBy: 'Pending To Branch By',
    brandDeliveredBy: 'Brand Delivered By',
    deliveredBy: 'Delivered By',
    archivedBy: 'Archived By'
  },
  home: {
    welcomeTitle: 'Welcome to the Lasshopping',
    pleaseFillOutInfo: 'Please fill out these information',
    processWasSuccessful: 'The process was successful',
    realEmailHint: 'The email must be a real email, because every actions on your order will send to this email'
  },
  forceUpdate: {
    updateTitle: 'Update Force Update',
    addTitle: 'Add New Force Update',
    minBuildNumberLabel: 'Minimum Required Build Number',
    minBuildNumberHint: 'Any installed app below this build number will be forced to update.',
    operatingSystemLabel: 'Operating System',
    imageMustBeImageError: 'File type must be an image',
    minBuildNumberColumn: 'Min. Build Number',
    softUpdateType: 'Soft',
    hardUpdateType: 'Hard'
  },
  editCredit: {
    title: 'Edit Credit',
    updatedSuccessfully: 'Credit updated successfully'
  },
  addEditSubscription: {
    addTitle: 'Add Subscription',
    addNewButton: 'Add New Subscription',
    nameLabel: 'Subscription Name',
    deleteSubscriptionConfirm: 'Delete subscription: {name}?',
    deleteUserSubscriptionConfirm: 'Delete user subscription: {name}?'
  },
  addEditOrderType: {
    addTitle: 'Add OrderType',
    nameLabel: 'Type Name',
    addNewButton: 'Add New Order Type'
  },
  prepareToPrint: {
    arrivedDateLabel: 'Arrived date:',
    signatureLabel: 'Signature'
  },
  exportOrder: {
    cancelTitle: 'Cancel Export Order'
  },
  editTransportationType: {
    title: 'Edit Transportation Type'
  },
  invoicePaymentLogs: {
    title: 'Payment Logs',
    paidAfterColumn: 'Paid After',
    remainingAfterColumn: 'Remaining After',
    noPaymentsRecordedYet: 'No payments recorded yet'
  },
  editProductName: {
    title: 'Edit Product Name',
    updatedSuccessfully: 'Product Name updated successfully'
  },
  sendToWarehouse: {
    title: 'Send order to warehouse'
  },
  sendToShipment: {
    title: 'Send order to shipment'
  },
  sendNotification: {
    title: 'Send Notification',
    sendToAllLabel: 'Send To All',
    sendToDeliveredLabel: 'Send To Delivered Orders Customers',
    selectCustomerLabel: 'Select Customer',
    bodyLabel: 'Body',
    historyTitle: 'Previously Sent',
    historyEmptyLabel: 'No notifications sent yet',
    useAgainTooltip: 'Use this message',
    audienceAllLabel: 'All customers',
    audienceDeliveredOnlyLabel: 'Delivered orders customers',
    audienceCustomSuffix: 'customers',
    recipientsLabel: 'Recipients'
  },
  ourAddress: {
    searchPlaceholder: 'Search...',
    transByColumn: 'TransBy',
    ourAddressesTitle: 'Our Addresses'
  },
  homeBanner: {
    isCounterLabel: 'Is Counter',
    titleArabicLabel: 'Title Arabic',
    titleKurdishLabel: 'Title Kurdish',
    descriptionArabicLabel: 'Description Arabic',
    descriptionKurdishLabel: 'Description Kurdish',
    startDateLabel: 'Start Date',
    endDateLabel: 'End Date',
    colorDarkLabel: 'Color Dark',
    backgroundColorLabel: 'Background Color',
    backgroundColorDarkLabel: 'Background Color Dark',
    titleRequiredError: 'Title is required',
    titleArabicRequiredError: 'Title Arabic is required',
    titleKurdishRequiredError: 'Title Kurdish is required',
    startDateRequiredError: 'Start date is required',
    endDateRequiredError: 'End date is required',
    endDateAfterStartDateError: 'End date must be after start date',
    colorHexError: 'Color must be a valid hex color code',
    descriptionRequiredError: 'Description is required',
    descriptionArabicRequiredError: 'Description Arabic is required',
    descriptionKurdishRequiredError: 'Description Kurdish is required'
  },
  customerPrices: {
    updatedSuccessfully: 'Customer Prices updated successfully',
    baseQttChargeUsaLabel: 'Base Qtt charge (USA)',
    otherQttChargeUsaLabel: 'Other Qtt charge (USA)'
  },
  kreenexFeePrices: {
    updatedSuccessfully: 'ShipZone fee prices updated successfully',
    feePercentageLabel: 'ShipZone fee percentage',
    feeBaseUsaLabel: 'ShipZone fee base (USA)',
    feeUsaLabel: 'ShipZone fee (USA)',
    explanationInPrefix: 'In',
    explanationIfLessThan: 'if',
    explanationLessThan: 'less than',
    explanationWillBe: 'will be',
    explanationOtherwise: ', Otherwise',
    explanationFormula: 'ShipZone fee (usa) + (item_price * ShipZone fee percentage)'
  },
  orderStatusSettings: {
    title: 'Order Status Settings',
    description: 'Rename, recolor, or hide any order status. A hidden status disappears from status pickers, filters, and navigation across the admin, customer website, and mobile app — the underlying status logic (transitions, refunds, etc.) keeps working unchanged either way.',
    displayNameEnColumn: 'Display Name (EN)',
    displayNameArColumn: 'Display Name (AR)',
    displayNameKuColumn: 'Display Name (KU)',
    displayNameTrColumn: 'Display Name (TR)',
    visibleColumn: 'Visible',
    egNewOrderPlaceholder: 'e.g. New Order',
    failedToSaveOneOrMoreStatuses: 'Failed to save one or more statuses'
  },
  changeOrderStatus: {
    title: 'Change Order Status',
    ordersSelectedSuffix: 'order(s) selected',
    orderColonPrefix: 'Order:',
    alreadyPurchasedBeforeInfo: 'This order was already purchased before — it will be moved back to Purchased directly, no need to re-enter these details.',
    actualPriceCalculatedAutomatically: 'Actual price will be calculated per order automatically.',
    refundReasonRequiredLabel: 'Refund Reason*',
    moneyAmountLabel: 'Money Amount',
    eachOrderRefundedFullRemaining: 'Each order will be refunded its full remaining amount.',
    savingLabel: 'Saving...',
    unmarkOrdersAsClearedConfirm: 'Unmark {count} order(s) as cleared? They will reappear in this list under the Active filter.',
    orderAlreadyHasInvoiceMessage: 'Order {orderId} already has a {status} invoice{invoiceNumber}. Continuing won\'t charge the customer again. Continue?',
    ordersAlreadyHaveInvoiceMessage: 'The following order(s) already have a paid or partially paid invoice:\n\n{lines}\n\nContinuing won\'t charge the customer again for them. Continue?',
    orderAlreadyPurchasedRefundWarning: 'This order has already been purchased/shipped. Canceling it will also automatically issue a full refund of up to ${amount} to the customer.',
    statusLockedOrderCanceled: 'Status locked — order is canceled',
    clickToChangeStatus: 'Click to change status',
    failedToChangeOrderStatus: 'Failed to change order status',
    ordersUpdatedSuccessfully: 'Orders updated successfully'
  },
  shipOnly: {
    orderNoteColumn: 'Order Note',
    whDateColumn: 'WH Date',
    warehousePassedLabel: 'Warehouse Passed',
    warehouseDateChangedSuccessfully: 'Warehouse date changed',
    orderPriceLabel: 'Order price',
    willPayOption: 'Will pay',
    loanOption: 'Loan',
    allOrdersApprovedAndPurchased: 'All selected orders have been approved and purchased.',
    goToCustomerCreditLink: 'Go to customer credit',
    addShipOnlyTitle: 'ADD SHIP ONLY'
  },
  activityLog: {
    accountTypeLabel: 'Account type',
    allAccountsOption: 'All accounts',
    allPlatformsOption: 'All platforms',
    adminWebOption: 'Admin (web)',
    mobileIosOption: 'Mobile (iOS)',
    mobileAndroidOption: 'Mobile (Android)',
    accountNameLabel: 'Account (name)',
    searchStaffOrCustomerPlaceholder: 'Search staff or customer name',
    eventLabel: 'Event',
    eventPlaceholder: 'e.g. post, approved, login',
    subjectTypeLabel: 'Subject type',
    subjectTypePlaceholder: 'e.g. Order, Invoice',
    routeOrDescriptionPlaceholder: 'Route or description',
    showingHistoryForPrefix: 'Showing history for',
    accountColumn: 'Account',
    guestLabel: 'Guest'
  },
  customerDeviceIcon: {
    orderedViaMobileApp: 'Ordered via Mobile App',
    orderedViaWeb: 'Ordered via Web',
    addedByAdminStaff: 'Added by Admin/Staff',
    unknownSourceLegacyOrder: 'Unknown source (legacy order)'
  },
  editBank: {
    title: 'Edit Bank',
    loadingBanks: 'Loading banks...',
    selectBankLabel: 'Select Bank'
  },
  editEntityField: {
    editTypeTitle: 'Edit Type',
    typeUpdatedSuccessfully: 'Type updated successfully',
    editSizeTitle: 'Edit Size',
    sizeUpdatedSuccessfully: 'Size updated successfully',
    editColorTitle: 'Edit Color',
    colorUpdatedSuccessfully: 'Color updated successfully'
  },
  editPriceForCountry: {
    priceUpdatedSuccessfully: 'Price updated successfully',
    pricePerWeightTurkeyLabel: 'Price per weight for Turkey',
    pricePerWeightUsaLabel: 'Price per weight for USA'
  },
  editQuantity: {
    title: 'Edit Quantity',
    updatedSuccessfully: 'Quantity updated successfully'
  },
  editQuantityCharge: {
    usaOtherLabel: 'USA Other Quantity Charge',
    usaOtherUpdatedSuccessfully: 'USA Other Quantity Charge updated successfully',
    turkeyOtherLabel: 'Turkey Other Quantity Charge',
    turkeyOtherUpdatedSuccessfully: 'Turkey Other Quantity Charge updated successfully',
    usaBaseLabel: 'USA Base Quantity Charge',
    usaBaseUpdatedSuccessfully: 'USA Base Quantity Charge updated successfully',
    turkeyBaseLabel: 'Turkey Base Quantity Charge',
    turkeyBaseUpdatedSuccessfully: 'Turkey Base Quantity Charge updated successfully'
  },
  giveToCustomer: {
    title: 'Edit Percentage',
    givenSuccessfully: 'Coupon gave to customer successfully',
    giveButton: 'Give'
  },
  editProductUrl: {
    title: 'Edit ProductUrl',
    updatedSuccessfully: 'ProductUrl updated successfully'
  },
  addRefundNumber: {
    title: 'Add Refund Number',
    addedSuccessfully: 'Refund number added successfully'
  },
  mobileDatatable: {
    infoAndDateColumn: 'Info & Date',
    staffDetailColumn: 'Staff Detail',
    infoAndStatusColumn: 'Info & Status',
    customerDetailColumn: 'Customer Detail',
    invoiceDetailColumn: 'Invoice Detail',
    actionAndDateColumn: 'Action & Date',
    couponDetailColumn: 'Coupon Detail',
    statusAndDatesColumn: 'Status & Dates',
    customerAndDateColumn: 'Customer & Date',
    staffAndCustomerColumn: 'Staff & Customer',
    statusAndDateColumn: 'Status & Date',
    rateDetailColumn: 'Rate Detail',
    dateAndActionsColumn: 'Date & Actions'
  },
  shippingPrices: {
    title: 'Shipping prices (Turkey)',
    updatedSuccessfully: 'Shipping prices updated successfully',
    pleaseUpdateAnythingError: 'Please update anything',
    addTypeButton: 'Add type'
  },
  phoneInput: {
    searchCountryLabel: 'Search country',
    noMatches: 'No matches',
    phoneRequiredError: 'Phone number is required',
    phoneNotCorrectError: 'Phone number is not correct'
  },
  orderImage: {
    title: 'Order Image',
    openCameraButton: 'Open Camera',
    closeCameraButton: 'Close Camera',
    flipCameraButton: 'Flip Camera',
    downloadLink: 'Download',
    cameraNotSupportedError: "May the browser didn't support or there is some errors.",
    imageSavedMessage: 'Image Saved'
  },
  logs: {
    cashBackInvoiceTitle: 'CashBack Invoice',
    exRateLabel: 'Ex Rate',
    failedToMergeSelectedInvoices: 'Failed to merge the selected invoices.',
    receiptLabel: 'Receipt',
    creditInvoiceNumber: 'Credit Invoice Number',
    customerAddress: 'Customer Address',
    customerTel: 'Customer Tel',
    oldAmount: 'Old Amount',
    newAmount: 'New Amount',
    totalIqdLabel: 'Total IQD',
    refundInvoiceTitle: 'Refund Invoice',
    shoppingOnlineInvoiceTitle: 'Shopping Online Invoice',
    orderNumberColon: 'Order #:',
    itemColumn: 'Item',
    refundReasonPrefix: 'Refund —',
    deliveryPriceColon: 'Delivery Price:',
    deliveryColon: 'Delivery:',
    shipZoneFeeColon: 'ShipZone Fee:',
    deliveryIraqiPriceColon: 'Delivery Iraqi Price:',
    phoneColon: 'Phone:',
    emailColon: 'Email:',
    signatureLabel: 'Signature: _______________________________',
    orderNoColumn: 'Order No.',
    remainColumn: 'Remain',
    subTotalLabel: 'Sub Total:',
    totalPaidLabel: 'Total Paid:',
    totalRemainingLabel: 'Total Remaining:',
    totalReceivedLabel: 'Total Received:',
    totalRemainLabel: 'Total Remain:'
  },
  whatsappTemplate: {
    sendWhatsappMessageLabel: 'Send Whatsapp Message',
    englishMessageLabel: 'English Message',
    arabicMessageLabel: 'Arabic Message',
    kurdishMessageLabel: 'Kurdish Message',
    saveAsDefaultTemplateButton: 'Save as Default Template',
    deliverToBranchTitle: 'Deliver to Branch',
    sendAllToBranchTitle: 'Send All to Branch',
    templateSavedSuccessfully: 'Template saved successfully',
    failedToSaveTemplate: 'Failed to save template'
  },
  orderLog: {
    yourStaffLabel: 'your staff',
    yourCustomerLabel: 'your customer',
    requestedVerb: 'requested',
    theOrderConnector: 'the order',
    deliveredTheOrderLabel: 'delivered the order',
    toConnector: 'to',
    shippedVerb: 'shipped',
    processedVerb: 'processed',
    canceledVerb: 'canceled',
    approvedVerb: 'approved',
    refundedVerb: 'refunded',
    purchasedVerb: 'purchased',
    sentToBranchVerb: 'sent to branch',
    atConnector: 'at'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js